<template>
    <section class="log-out">
        <app-confirmation title="Log Out"
                          class="log-out__confirmation"
                          confirm-text="Log Out"
                          confirm-icon-class="fas fa-sign-out-alt"
                          @cancel="onCancel"
                          @confirm="onLogOut">
            <p class="log-out__confirmation__text">
                This will log you out of the application. Are you sure you want to do this?
            </p>
        </app-confirmation>
    </section>
</template>

<script>

import Vuex from 'vuex'

import AuthManager from '../../../auth/auth-manager'

import AppConfirmation from '../../app-core/app-confirmation'

export default {

    computed: {

        ...Vuex.mapGetters([
            'userSignedIn',
        ]),
    },

    methods: {

        onCancel(ev) {
            this.$eventbus.$emit(this.$appevents.hideModal, ev)
        },

        async onLogOut(ev) {
            try {
                await AuthManager.logOutAsync()
                this.$eventbus.$emit(this.$appevents.hideModalWithoutActions, ev)
                this.$router.push({ name: 'Welcome' })
            } catch (err) {
                this.error = `Log out failed: ${ err.message }`
                throw err
            }
        },
    },

    components: {
        AppConfirmation,
    },
}

</script>

<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.
// src\scss\schemes\components\auth\modals\_log-out-confirmation.scss

.log-out {

    @include element('confirmation') {

        @include element('text') {
            text-align: center;
        }
    }

    @include element('buttons') {
        padding-top: 10px;
        width: 100%;
        display: flex;
    }
}

</style>
